import { render } from "./DownloadPageEditor.vue?vue&type=template&id=6cb01242&scoped=true"
import script from "./DownloadPageEditor.vue?vue&type=script&lang=js"
export * from "./DownloadPageEditor.vue?vue&type=script&lang=js"

import "./DownloadPageEditor.vue?vue&type=style&index=0&id=6cb01242&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb01242"]])

export default __exports__